// Decision 7 (see colmar-be-migration/.claude/wwg-experience-ticket-widget-context.md):
// UAT-only visibility is gated at runtime via hostname, not a build-time
// REACT_APP_ENV var, so the same bundle can run anywhere and no Bitbucket
// pipeline change is needed. `localhost` covers "test" (npm run start:dev)
// for any port, since the port is never part of `location.hostname`.
const SUPPORT_WIDGET_ALLOWED_HOSTNAMES = [
  'catalogue.uat.colmar.com',
  'catalogue-new.stage.colmar.com',
  'localhost',
];

export function isSupportWidgetEnabled(): boolean {
  return SUPPORT_WIDGET_ALLOWED_HOSTNAMES.includes(window.location.hostname);
}
